import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { usePageMeta } from "@/lib/seo";

export default function NotFound() {
  const location = useLocation();
  usePageMeta({
    title: "页面不存在 - 枫与铃",
    description: "你访问的页面不存在或已移动，可以返回首页继续浏览影视推荐与资讯。",
  });

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main className="pt-[72px]">
        <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center px-4 py-24 text-center md:px-8">
          <span className="font-heading text-6xl font-bold text-primary-500 md:text-8xl">404</span>
          <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            这个页面不在片单里
          </h1>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
            你访问的地址可能已经变更或输入有误。可以回到首页，或从分类开始重新寻找。
          </p>
          <p className="mt-2 text-xs text-foreground-400">{location.pathname}</p>
          <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              返回首页
            </Link>
            <Link
              to="/search"
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              去搜索
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}